import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import ResponseCard from './ResponseCard';
import {useFormsContext} from '../../../../../../context/forms/FormsContextProvider';
import ResponderNavigator from './ResponderNavigatior';

function groupByResponders(data: any[]) {
  const respondersMap: {[key: string]: any} = {};

  data.forEach(item => {
    const question = item.question;

    item.answers.forEach((ans: any) => {
      const responderId = ans.responseId;

      // If responder not added yet
      if (!respondersMap[responderId]) {
        respondersMap[responderId] = {
          responder: ans.responder,
          responses: [],
        };
      }

      // Push question + answer
      respondersMap[responderId].responses.push({
        question: question,
        answer: ans,
      });
    });
  });

  return Object.values(respondersMap);
}

function ResponsesByUser({
  printableRef,
}: {
  printableRef: React.RefObject<HTMLDivElement | null>;
}) {
  const {t} = useTranslation();
  const [currentResponderIndex, setCurrentResponderIndex] = useState(0);
  const {formData} = useFormsContext();

  const data = groupByResponders(formData?.responses || []);

  // const data = MOCK_RESPONSES_DATA;
  const totalResponders = data.length;
  const currentResponder = data?.[currentResponderIndex];

  const handlePrev = () => {
    setCurrentResponderIndex(prev => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentResponderIndex(prev => Math.min(totalResponders - 1, prev + 1));
  };

  // Empty state
  if (totalResponders === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-12 min-h-[300px]">
        <div className="text-center">
          <p className="text-xl text-gray">
            {t('forms.dialog.responses.empty')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 flex flex-col" ref={printableRef}>
      {/* Question navigator */}
      <ResponderNavigator
        responderName={currentResponder?.responder?.name}
        responderEmail={currentResponder?.responder?.email}
        currentIndex={currentResponderIndex}
        totalQuestions={currentResponder?.responses?.length}
        totalResponders={totalResponders}
        showTotalResponders={formData?.countRespondents}
        onPrev={handlePrev}
        onNext={handleNext}
      />

      {/* Border separator */}
      <div className="border-t border-gray80 mt-4 flex-shrink-0" />

      {/* Scrollable response list */}
      <div className="flex-1 min-h-0 overflow-y-auto mt-4 flex flex-col gap-3">
        {currentResponder?.responses?.map((response: any, idx: number) => {
          const {linearScale, rating, image, rangeConfig} =
            response?.question || {};
          const metaData = {
            maxRating: rating?.max,
            ratingIcon: rating?.icon,
            // For linear-scale questions
            fromValue: linearScale?.min,
            toValue: linearScale?.max,
            fromLabel: linearScale?.minLabel,
            toLabel: linearScale?.maxLabel,
            // question image
            qImage: image,
            qRange: rangeConfig,
          };
          return (
            <ResponseCard
              key={idx}
              response={response?.answer}
              questionType={response?.question?.type}
              metadata={metaData}
              question={response?.question?.title}
              isResponseByUserCard={true}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ResponsesByUser;
